export default {
  draft(state) {
    return state.controls.filter((control) => control.status === 'Draft')
  },
  active(state) {
    return state.controls.filter((control) => control.status === 'Active')
  },
}
